export const header: object = {
  header: {
    secureText: 'Secure',
    returnToSap4me: 'Return to SAP for Me',
    returnToCart: 'Return to Cart',
    aria: {
      returnTo: 'Return to.',
      sapStoreCart: 'SAP Store Cart. Return to.',
      sapStoreCheckout: 'SAP Store Checkout. Return to.',
    }
  }
};
